
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import {HomePartner} from '@/models/home-partner';
  import HomePartnerDetail from './HomePartnerDetail.vue';
  import SectionLayout from '../../SectionLayout.vue';
  import {Subscription} from 'vue-rx-decorators';
  import {HomePartnersApi} from '@/api/home-partners.api';
  import {Observable} from 'rxjs';
  import {take} from 'rxjs/operators';

  @Component({
    components: {
      HomePartnerDetail,
      SectionLayout
    }
  })
  export default class HomePartnerships extends Vue {

    @Subscription()
    get partners$(): Observable<HomePartner[]> {
      return new HomePartnersApi().all();
    }

    selectedPartner: HomePartner | null = null;

    mounted() {
      new HomePartnersApi().all().pipe(take(1)).subscribe((partner) => this.selectedPartner = partner[0]);
    }
  }
